/**
 * Created by fajar on 03/12/2018.
 * Updated by cahyo
 *
 * File environment for development
 * this file can import by alias 'environment'
 */

import BaseEnvironment from './BaseEnvironment';

export default ((ENV: any) => {

    ENV.LOGGER = true;
    ENV.NODE_ENV = process.env.NODE_ENV;
    ENV.BASE_API = process.env.RESOURCE["BASE_API"];
    ENV.CDN_URL = process.env.RESOURCE["CDN_URL"];
    ENV.USER_API = ENV.BASE_API + 'v1/users';
    ENV.LOGIN_API = ENV.BASE_API + 'v1/users/login';
    ENV.ASRAMA_API = ENV.BASE_API + 'v1/asramas';
    ENV.UANG_SAKU_API = ENV.BASE_API + 'v1/uang-sakus';
    ENV.MERCHANT_API = ENV.BASE_API + 'v1/merchants';
    ENV.CASHIER_API = ENV.BASE_API + 'v1/merchants/cashier';
    ENV.BIAYA_API = ENV.BASE_API + 'v1/biayas';
    ENV.SERAGAM_API = ENV.BASE_API + 'v1/seragams';
    ENV.TRANSAKSI_VIRTUAL_ACCOUNT_API = ENV.BASE_API + 'v1/virtual-accounts';
    ENV.PERSYARATAN_API = ENV.BASE_API + 'v1/persyaratans';
    ENV.DAFTAR_PEMBAYARAN_API = ENV.BASE_API + 'v1/daftar-pembayarans';
    ENV.POS_PEMBAYARAN_API = ENV.BASE_API + 'v1/pos-pembayarans';
    ENV.ITEM_PEMBAYARAN_API = ENV.BASE_API + 'v1/item-pembayarans';
    ENV.PEMBAYARAN_SANTRI_API = ENV.BASE_API + 'v1/pembayaran-santris';
    ENV.PENGAMBILAN_KITAB_API = ENV.BASE_API + 'v1/pengambilan-kitabs';
    ENV.PENDAFTAR_API = ENV.BASE_API + 'v1/pendaftars';
    ENV.MOBILE_API = ENV.BASE_API + 'v1/mobile/pendaftar/kwitansi';
    ENV.BIAYA_PENDAFTAR_API = ENV.BASE_API + 'v1/pendaftars/biaya';
    ENV.PERSYARATAN_PENDAFTAR_API = ENV.BASE_API + 'v1/pendaftars/persyaratan';
    ENV.SERAGAM_PENDAFTAR_API = ENV.BASE_API + 'v1/pendaftars/seragam';
    ENV.REKAPITULASI_API = ENV.BASE_API + 'v1/rekapitulasi';
    ENV.DASHBOARD_API = ENV.BASE_API + 'v1/dashboard';
    ENV.SANTRI_API = ENV.BASE_API + 'v1/santris';
    ENV.PENARIKAN_DANA_API = ENV.BASE_API + 'v1/penarikan-danas';
    ENV.PENARIKAN_DANA_MERCHANT_API = ENV.BASE_API + 'v1/penarikan-dana-merchant';
    ENV.CONFIGURATION_API = ENV.BASE_API + 'v1/configuration';
    ENV.BANK_SOAL_API = ENV.BASE_API + 'v1/bank-soals';
    ENV.PRESENSI_KEGIATAN_API = ENV.BASE_API + 'v1/presensi/kegiatan';
    ENV.PRESENSI_GURU_PENGAJIAN_API = ENV.BASE_API + 'v1/presensi/guru/pengajian';
    ENV.WAKAF_API = ENV.BASE_API + 'v1/wakaf/programs';
    ENV.WAKAF_CATEGORY_API = ENV.BASE_API + 'v1/wakaf/categories';
    ENV.TAGIHAN_API = ENV.BASE_API + 'v1/tagihan';
    ENV.TUK_API = ENV.BASE_API + 'v1/tuk';

    return ENV;
})(BaseEnvironment);
